import * as THREE from "three";
import { keyStrings, mouseButtons } from "../../../../constants";
import { defaultMRIZoom } from "./viewer";

const Raycaster = new THREE.Raycaster();

const Mouse = {};

const setMouse = (e, mount) => {
    let rect = mount.getBoundingClientRect();
    Mouse.x = ((e.clientX - rect.left) / mount.clientWidth) * 2 - 1;
    Mouse.y = -((e.clientY - rect.top) / mount.clientHeight) * 2 + 1;
};

const checkMouseBounds = () =>
    Mouse.x < -1 || Mouse.x > 1 || Mouse.y < -1 || Mouse.y > 1;

export function onWindowResize() {
    if (this.mount) {
        this.camera.left = (this.mount.clientWidth / -2) * (1 / defaultMRIZoom);
        this.camera.right = (this.mount.clientWidth / 2) * (1 / defaultMRIZoom);
        this.camera.top = (this.mount.clientHeight / 2) * (1 / defaultMRIZoom);
        this.camera.bottom =
            (this.mount.clientHeight / -2) * (1 / defaultMRIZoom);
        this.camera.updateProjectionMatrix();

        if (this.props.mriModel) {
            this.props.mriModel.updateContourTextures();
        }

        this.renderer.setSize(this.mount.offsetWidth, this.mount.offsetHeight);
    }
}

export function setRendererSize(width, height) {
    this.renderer.setSize(width, height);
}

export function onMouseDown(e) {
    if (!this.mount) {
        return;
    }

    setMouse(e, this.mount);

    if (checkMouseBounds()) {
        return;
    }

    switch (e.which) {
        case mouseButtons.LEFT: {
            Raycaster.setFromCamera(Mouse, this.camera);

            if (this.isMeshEditingActive()) {
                this.moving = true;
                this.props.meshEditController.updateCursor(this.moving);
            }

            break;
        }
        default:
            break;
    }
}

export function onMouseUp(e) {
    if (!this.mount) {
        return;
    }

    setMouse(e, this.mount);

    if (checkMouseBounds()) {
        return;
    }

    switch (e.which) {
        case mouseButtons.LEFT: {
            Raycaster.setFromCamera(Mouse, this.camera);
            if (this.moving) {
                this.props.meshEditController.smooth();
                this.moving = false;
                this.props.meshEditController.updateCursor(this.moving);

                this.props.meshEditController.endEdit();
            }

            break;
        }
        default:
            break;
    }
}

export function onMouseLeave() {
    if (this.moving) {
        this.props.meshEditController.smooth();
        this.moving = false;
        this.props.meshEditController.updateCursor(this.moving);

        this.props.meshEditController.endEdit();
    }
}

export function onMouseMove(e) {
    if (!this.mount) {
        return;
    }

    const oldMouse = new THREE.Vector2(Mouse.x, Mouse.y);

    setMouse(e, this.mount);

    const mouseDelta = new THREE.Vector2(Mouse.x, Mouse.y).sub(oldMouse);

    if (checkMouseBounds()) {
        return;
    }

    Raycaster.setFromCamera(Mouse, this.camera);

    switch (e.which) {
        case mouseButtons.NONE: {
            if (this.isMeshEditingActive()) {
                this.props.meshEditController.selectVertex(Raycaster);
                this.props.meshEditController.updateVerticesToMoveAndSmooth();
            }

            break;
        }

        case mouseButtons.LEFT: {
            if (this.moving) {
                this.props.meshEditController.startEdit();

                this.props.meshEditController.move(mouseDelta);
            }

            break;
        }

        default:
            break;
    }

    if (this.isMeshEditingActive()) {
        this.props.meshEditController.highlight();
    }
}

export function onClick(e) {
    if (!this.mount) {
        return;
    }

    setMouse(e, this.mount);

    if (checkMouseBounds()) {
        return;
    }

    Raycaster.setFromCamera(Mouse, this.camera);
}

export function onKeyDown(e) {
    if (!this.isMeshEditingActive()) {
        return;
    }

    switch (e.key) {
        case keyStrings.ARROW_UP:
        case keyStrings.ARROW_DOWN: {
            if (this.moving) {
                this.props.meshEditController.smooth();
            }
            this.props.meshEditController.maxUpdateDistance +=
                e.key === keyStrings.ARROW_UP ? 1 : -1;
            this.props.meshEditController.updateVerticesToMoveAndSmooth();
            this.props.meshEditController.highlight();

            break;
        }
        case keyStrings.COMMA: {
            this.props.meshEditController.undo();

            break;
        }
        case keyStrings.PERIOD: {
            this.props.meshEditController.redo();

            break;
        }

        default:
            return;
    }
}
